import { Menubar as BaseMenubar } from '@base-ui/react/menubar'
import { Menu as BaseMenu } from '@base-ui/react/menu'
import { forwardRef, type ComponentProps, type ReactNode } from 'react'

interface MenubarProps extends ComponentProps<typeof BaseMenubar> {
  children: ReactNode
}

interface MenubarMenuProps extends ComponentProps<typeof BaseMenu.Root> {
  children: ReactNode
}

const MenubarRoot = forwardRef<HTMLDivElement, MenubarProps>(function MenubarRoot(
  { children, className, ...props },
  ref,
) {
  return (
    <BaseMenubar ref={ref} className={className} {...props}>
      {children}
    </BaseMenubar>
  )
})

function MenubarMenu({ children, ...props }: MenubarMenuProps): JSX.Element {
  return <BaseMenu.Root {...props}>{children}</BaseMenu.Root>
}

export const Menubar = Object.assign(MenubarRoot, {
  Menu: MenubarMenu,
})
